import { Component } from '@angular/core';
import DatatableExtension from '@app/datatables/decorators/datatable-extension.decorator';
import { DatatablePagination } from '@app/shared/components/datatable-pagination';

declare module 'datatables.net' {
  interface Feature {
    simplePagination?: boolean;
  }
}

@Component({
  selector: 'portal-datatable-simple-pagination',
  templateUrl: './datatable-simple-pagination.component.html',
  standalone: false,
})
@DatatableExtension({
  componentElement: '<portal-datatable-simple-pagination></portal-datatable-simple-pagination>',
  key: 'S',
  name: 'simplePagination',
})
export class DatatableSimplePaginationComponent extends DatatablePagination {}
